import React, { useState } from 'react';
import { useStripe } from '@stripe/react-stripe-js';
import { AccountHolderForm } from './AccountHolderForm';
import { PaymentConfirmationForm } from './PaymentConfirmationForm';
import { BankAccountDetails } from './types';

import { FLOWS_ENUM } from 'src/common/enums';

interface ACHProps {
  flow: FLOWS_ENUM;
  onSuccess: () => void;
}

const ACH = ({ flow, onSuccess }: ACHProps) => {
  const stripe = useStripe();

  const [clientSecret, setClientSecret] = useState<string>();
  const [bankAccountDetails, setBankAccountDetails] =
    useState<BankAccountDetails>({});

  return (
    <>
      {!clientSecret && (
        <AccountHolderForm
          flow={flow}
          setBankAccountDetails={setBankAccountDetails}
          setClientSecret={setClientSecret}
          stripe={stripe}
        />
      )}
      {clientSecret && (
        <PaymentConfirmationForm
          bankAccountDetails={bankAccountDetails}
          clientSecret={clientSecret}
          onSuccess={onSuccess}
          setBankAccountDetails={setBankAccountDetails}
          setClientSecret={setClientSecret}
          stripe={stripe}
        />
      )}
    </>
  );
};

export default ACH;
